import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  resetAppIndicator: false,
  keepFiltersOnReset: false,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    triggerResetApp: state => {
      state.resetAppIndicator = true;
    },
    clearResetApp: state => {
      state.resetAppIndicator = false;
    },
    setKeepFiltersOnReset: (state, action) => {
      state.keepFiltersOnReset = action.payload;
    },
  },
});

export const selectResetAppIndicator = state =>
  state.navigation.resetAppIndicator;

export const selectKeepFiltersOnReset = state =>
  state.navigation.keepFiltersOnReset;

export const {
  triggerResetApp,
  clearResetApp,
  setKeepFiltersOnReset,
} = navigationSlice.actions;

export default navigationSlice.reducer;
